/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Fragment } from 'react';
import { Link } from 'gatsby';
import { Location } from '@reach/router';
import {
  AtlassianNavigation,
  generateTheme,
  PrimaryButton,
  useOverflowStatus,
} from '@atlaskit/atlassian-navigation';
import { LinkItem } from '@atlaskit/menu';
import { N900, B200 } from '@atlaskit/theme/colors';
import { useThemeObserver } from '@atlaskit/tokens';
import Search from './search';
import Logo from './logo';

const theme = generateTheme({
  name: 'dark',
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  backgroundColor: N900,
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  highlightColor: B200,
});

const NavItem = ({ href, pathname, ...rest }) => {
  const { isVisible } = useOverflowStatus();
  return isVisible ? (
    <PrimaryButton
      /*
        We are using `startsWith so that sub-pages in each section also cause the correct location to be highlighted
      */
      {...rest}
      isHighlighted={pathname.startsWith(href)}
      component={Link}
      // @ts-expect-error
      to={href}
    />
  ) : (
    <LinkItem href={href} isSelected={pathname.startsWith(href)}>
      {rest.children}
    </LinkItem>
  );
};

const TopNav = () => {
  const globalTheme = useThemeObserver();

  return (
    <Fragment>
      {/* BC: location is undefined in SSR calls, so we are defaulting it to an empty object */}
      <Location>
        {({ location = {} }) => (
          <AtlassianNavigation
            label="site navigation"
            theme={globalTheme ? undefined : theme}
            renderProductHome={() => (
              <Link to="/">
                <Logo theme={globalTheme} />
              </Link>
            )}
            renderSearch={Search}
            primaryItems={[
              <NavItem pathname={location.pathname} href="/brand">
                Brand
              </NavItem>,
              <NavItem pathname={location.pathname} href="/foundations">
                Foundations
              </NavItem>,
              <NavItem pathname={location.pathname} href="/content">
                Content
              </NavItem>,
              <NavItem pathname={location.pathname} href="/components">
                Components
              </NavItem>,
              <NavItem pathname={location.pathname} href="/patterns">
                Patterns
              </NavItem>,
              <NavItem pathname={location.pathname} href="/resources">
                Resources
              </NavItem>,
            ]}
          />
        )}
      </Location>
    </Fragment>
  );
};

export default TopNav;
